import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** September 2026 toolkit */
export const mentalFitnessToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MENTAL_FITNESS,
  iFrameSrcUrl: '/mental-fitness',
  micrositeUrl: 'mental-fitness',
  title: {
    id: 'mentalFitnessToolkit.title',
    defaultMessage: 'Make mental fitness part of your routine',
    description: 'Microsite page title',
  },
  featureFlag: 'isMentalFitnessToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WELLNESS_CHECK_IN },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        eventKey: 'mindful-moments',
        webinarLink: '/secure/index/essentials/events/mindful-moments',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        eventKey: 'mental-fitness-for-leaders',
        webinarLink: '/secure/index/essentials/events/mental-fitness-for-leaders',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202609 mentalfitness',
  trackUTMParams: {
    utm_campaign: 'Sep926',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'Mental Fitness Routine',
  },
  shouldHideForInternational: false,
}
